import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { HeaderAndNavigationService } from '../headerandnavigation/headerandnavigation.service';
import { IBlog } from '../blogs/blog';
import { BlogService } from '../blogs/blog.service';
declare var $: any;
@Component({
  templateUrl: "./noaccess.component.html"
})
export class NoAccessComponent implements OnInit, AfterViewInit {
  public pageTitle: string = 'No Access';
  p: number = 1;
  blogsList: IBlog[];
  constructor(private authService: AuthService, private appCommonService: AppCommonService,   
    public blogService: BlogService,
    public headerAndNavigationService: HeaderAndNavigationService) {
   
  }
  ngOnInit() {
    //debugger
    $('#login').hide();
    $("#logout").css("display", "block");
    this.appCommonService.pageContentAdditionalClass = "home-page login-page";
    this.loadBlogsList();
    window.scrollTo(0, 0);
    //$('#logout').show();
  }

  ngAfterViewInit() {
    this.appCommonService.loadRequiredJS();
    //if (this.authService.checkShowWelcomeMessage()) {
    //  $('#welcomeModal').modal('show');
    //}

    $('.tabs-left li a').click(function () {
      $(this).parent().siblings().removeClass("active");
    });

    $('.tabs-left li a').hover(function () {
      $(this).trigger('click');
    });

    const selfMe = this;
    $('#welcomeModal').on('hidden.bs.modal', function () {
      selfMe.closeWelcomeWindow();
    });

    $('#homepage_video').on('show.bs.modal', function (e) {
      $("#video_homepage_video").attr('src', "https://www.youtube.com/embed/kNyQAEs_1QM?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
    });
    $('#homepage_video').on('hide.bs.modal', function (e) {
      $("#video_homepage_video").attr('src', "https://www.youtube.com/embed/kNyQAEs_1QM");
    });

    $('#fuel_card_account').on('show.bs.modal', function (e) {
      $("#video_fuel_card_account").attr('src', "https://www.youtube.com/embed/dYgCeuTX-q4?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
    });
    $('#fuel_card_account').on('hide.bs.modal', function (e) {
      $("#video_fuel_card_account").attr('src', "https://www.youtube.com/embed/dYgCeuTX-q4");
    });

    $('#business_advantage').on('show.bs.modal', function (e) {
      $("#video_business_advantage").attr('src', "https://www.youtube.com/embed/9y0iTMeBqJQ?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
    });
    $('#business_advantage').on('hide.bs.modal', function (e) {
      $("#video_business_advantage").attr('src', "https://www.youtube.com/embed/9y0iTMeBqJQ");
    });

    $('#drivers_club').on('show.bs.modal', function (e) {
      $("#video_drivers_club").attr('src', "https://www.youtube.com/embed/FvrX9dfoJUI?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
    });
    $('#drivers_club').on('hide.bs.modal', function (e) {
      $("#video_drivers_club").attr('src', "https://www.youtube.com/embed/FvrX9dfoJUI");
    });

    $('#fleet_solutions').on('show.bs.modal', function (e) {
      $("#video_fleet_solutions").attr('src', "https://www.youtube.com/embed/r_yrwkUoiLE?rel=0&amp;showinfo=0&amp;modestbranding=1&amp;autoplay=1");
    });
    $('#fleet_solutions').on('hide.bs.modal', function (e) {
      $("#video_fleet_solutions").attr('src', "https://www.youtube.com/embed/r_yrwkUoiLE");
    });

    $('.homepageslider').slick({
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      touchMove: true
    });


    $(".verticalslider").slick({
      dots: false,
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      vertical: true,
      verticalSwiping: true,
      responsive: [
        {
          breakpoint: 1580,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5
          }
        },
        {
          breakpoint: 881,
          settings: {
            vertical: false,
            verticalSwiping: false
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            vertical: false,
            verticalSwiping: false
          }
        },
        {
          breakpoint: 581,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            vertical: false,
            verticalSwiping: false
          }
        },
        {
          breakpoint: 376,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            vertical: false,
            verticalSwiping: false
          }
        }
      ]
    });

    //this.route.fragment.subscribe((fragment: string) => {
    //  var Id = this.GetId(fragment);

    //  $("#p" + fragment).trigger('click');


    //  $('.verticalslider').slick('slickGoTo', Id);
    //})
  }

  closeWelcomeWindow() {
    $('#welcomeModal').modal('hide');
    this.authService.setShowWelcomeMessage();
  }

  loadBlogsList() {
    this.blogService.getBlogsList()
      .subscribe(
        (blogs: IBlog[]) => {
          // console.log(blogs);
          this.blogsList = blogs;
        },
        (error: any) => {
          this.blogService.showError("Blog retrieval problem", <any>error)
        }
      );
  }

  Logout() {
    this.headerAndNavigationService.ClearUserData();
    this.authService.logout();

  }
}



// WEBPACK FOOTER //
// ./src/app/users/noaccess.component.ts